import React from "react";
export function QuotePolicies(props) {
  const policies = {
    bookingPolicies: [
      `Bookings should be made minimum one week prior to the date of
      planned move out.`,
      `An advance payment of Rs.1500 should be made as “Token Amount”
      for booking confirmation.`,
      `If needed, customers are requested to provide authorized
      proofs for their ‘move-out’ and ‘move-in’ to avoid further
      inconvenience.`,
      `We cannot assure the prices or availability would remain the
      same if any changes made to your move date. However, boxigo
      strive to provide the best service to fulfill your need.`,
    ],
    cancellationPolicies: `Cancellation of any booking requires a minimum of 24 hours prior
    notice. Notification for instance, in person, via email, mobile
    phone ‘text message’, or any other means will be accepted subject
    to confirmation in writing. We reserve the right to levy a minimal
    charge to cover any subsequent administrative expenses.`,
  };
  const JSX = (
    <>
      <div className="quote-policies">
        <div className="row">
          <div className="col-sm-12 col-md-6">
            <div className="policy-label mb-3">Booking policies</div>
            <ul className="p-0">
              {policies["bookingPolicies"].map((bookingPolicy) => {
                return (
                  <li className="policy-list">
                    <div class="rectangle-icon"></div>
                    <span class="policy-text">{bookingPolicy}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className="policy-label mb-3">Cancellation Policies</div>
            <p className="policy-text">{policies["cancellationPolicies"]}</p>
          </div>
        </div>
      </div>
    </>
  );
  return JSX;
}
